module.exports = __webpack_public_path__ + "img/mega_logo.ce9519d5.png";